<template>
  <v-dialog v-model="dialog" max-width="560px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Editar webhook (Meta)</span>
      </v-card-title>

      <v-card-text>
        <v-alert v-if="error" type="error" dense class="mb-3">{{ error }}</v-alert>

        <p class="text-body-2 text--secondary mb-3">
          Encaminha uma cópia dos webhooks inbound da Meta para a URL abaixo
          (ex.: Chatwoot), após o processamento local.
        </p>

        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-text-field
            v-model="webhookRedirectUrl"
            label="URL de redirect do webhook"
            hint="Deixe em branco para desativar o encaminhamento"
            persistent-hint
            outlined
            dense
            clearable
            class="mb-2"
            :rules="urlRules"
          />

          <v-text-field
            v-model="webhookSigningSecret"
            label="Chave secreta para re-assinatura"
            :hint="secretHint"
            persistent-hint
            outlined
            dense
            type="password"
            autocomplete="new-password"
            clearable
          />

          <v-alert
            v-if="secretSet && !clearSecret"
            type="info"
            dense
            text
            class="mt-3"
          >
            Já existe uma chave secreta configurada. Deixe o campo em branco para
            mantê-la, ou preencha para substituir.
          </v-alert>

          <v-checkbox
            v-if="secretSet"
            v-model="clearSecret"
            label="Remover chave secreta (usar assinatura original da Meta)"
            dense
            hide-details
            class="mt-2"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">Cancelar</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MESSAGER from "@/services/admin/messager.js";

export default {
  name: "MetaAccountEditDialog",
  props: {
    value: { type: Boolean, default: false },
    account: { type: Object, default: null },
  },
  data: () => ({
    valid: false,
    saving: false,
    error: null,
    webhookRedirectUrl: "",
    webhookSigningSecret: "",
    clearSecret: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    secretSet() {
      return !!this.account?.webhookSigningSecretSet;
    },
    secretHint() {
      if (this.clearSecret) {
        return "A chave será removida ao salvar";
      }
      if (this.secretSet) {
        return "Em branco = manter a atual; preenchido = substituir";
      }
      return "Se vazio, encaminha com a assinatura original da Meta";
    },
    urlRules() {
      return [
        (v) => {
          if (!v || !String(v).trim()) return true;
          try {
            const u = new URL(String(v).trim());
            if (u.protocol !== "http:" && u.protocol !== "https:") {
              return "URL deve ser http ou https";
            }
            return true;
          } catch {
            return "URL inválida";
          }
        },
      ];
    },
  },
  watch: {
    value(open) {
      if (open) this.reset();
    },
    clearSecret(val) {
      if (val) this.webhookSigningSecret = "";
    },
  },
  methods: {
    reset() {
      this.error = null;
      this.saving = false;
      this.clearSecret = false;
      this.webhookSigningSecret = "";
      this.webhookRedirectUrl = this.account?.webhookRedirectUrl || "";
      this.$refs.form && this.$refs.form.resetValidation();
    },
    close() {
      this.dialog = false;
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      if (!this.account?.id) return;

      const payload = {
        webhookRedirectUrl: this.webhookRedirectUrl?.trim() || null,
      };

      if (this.clearSecret) {
        payload.webhookSigningSecret = null;
      } else if (this.webhookSigningSecret?.trim()) {
        payload.webhookSigningSecret = this.webhookSigningSecret.trim();
      }

      try {
        this.saving = true;
        this.error = null;
        await MESSAGER.accounts.update(this.account.id, payload);
        this.close();
        this.$emit("saved");
      } catch (error) {
        this.error = error.message || "Erro ao salvar configuração de webhook";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
